import { request } from '@umijs/max';

const AUTH_BASE_URL = process.env.Auth_URL || '';

let lastPath = '';

// 页面浏览信标:路由切换上报真实页面路径,游客也记。失败静默。
export function trackPageView(path: string) {
  if (!path || path === lastPath) return;
  lastPath = path;
  request(`${AUTH_BASE_URL}/api/track/pageview`, {
    method: 'POST',
    data: { path, referer: document.referrer || '' },
    skipErrorHandler: true,
  }).catch(() => {});
}
